import React, { type ComponentType } from 'react';
import type { FilterViewProps } from '../../../../../model/index.tsx';

type Props<TFilter> = {
	FilterView: ComponentType<FilterViewProps<TFilter>>;
} & FilterViewProps<TFilter>;

export default function Filter<TFilter>(props: Props<TFilter>): React.JSX.Element {
	const { FilterView, onFilter } = props;
	return <FilterView onFilter={onFilter} />;
}
